;(function (Wishlist, $) {
    var $wbwishlistBtn = $('.wbwishremove');
    var $wishlistCart = $('.cart');
    var $wbwishcount = $('.wbwishcount');
    var numProductTiles = $wishlistCart.length;
    var wishlist = localStorage.getItem('wbwishtems') || [];
    var wishcountall = localStorage.getItem('wbwishtemscount');

    

    $wbwishcount.html(wishcountall == null ? 0 : wishcountall);

    if (wishlist.length > 0) {
        wishlist = JSON.parse(localStorage.getItem('wbwishtems'));
    }
    var animateWishlist = function (e) {
        $(e).toggleClass('wishactive');
    };
    var updateWishlist = function (self) {
        var productHandle = $(self).attr('data-product-handle');
        var isRemove = $(self).hasClass('wishactive');
        //var wbwishcountvalue = localStorage.getItem('wbwishtemscount');
        if (isRemove) {
            var removeIndex = wishlist.indexOf(productHandle);
                wishlist.splice(removeIndex, 1);
            var wbwishcountp = localStorage.getItem('wbwishtemscount');
            if(wbwishcountp != null){
                var minus_val = -1;
                var wish_ct = Math.max(parseInt(wbwishcountp) + minus_val, 0);
                localStorage.setItem('wbwishtemscount', wish_ct);
            }
            localStorage.setItem('wbwishtems', JSON.stringify(wishlist));
            //var icon_length = $(self).find("span").length;
            if($(self).find("span").length != 0){
                $wbwishlistBtn.html('<span class="wbaddtowish"><svg><use xlink:href="#wish"></use></svg></span><span class="wbloadtowish wishanimated"><svg><use xlink:href="#refresh"></use></svg></span><span class="wbwishirmv"><svg viewBox="0 0 24 24" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/"><g transform="translate(0 -1028.4)"><path d="m7 1031.4c-1.5355 0-3.0784 0.5-4.25 1.7-2.3431 2.4-2.2788 6.1 0 8.5l9.25 9.8 9.25-9.8c2.279-2.4 2.343-6.1 0-8.5-2.343-2.3-6.157-2.3-8.5 0l-0.75 0.8-0.75-0.8c-1.172-1.2-2.7145-1.7-4.25-1.7z" fill="#fe3869"/></g></svg></span>');
            }
            //var wbwishcountp_value = localStorage.getItem('wbwishtemscount');
            $wbwishcount.html(localStorage.getItem('wbwishtemscount'));
        }
        else {
            wishlist.push(productHandle);
            var wbwishcountp = localStorage.getItem('wbwishtemscount');
            if(wbwishcountp == null){
                var plus_val = 1;
                var wish_ct = plus_val;
            }else{
            var plus_val = 1;
            var wish_ct = Math.max(parseInt(wbwishcountp) + plus_val, 0);
        }
            localStorage.setItem('wbwishtemscount',wish_ct);
            localStorage.setItem('wbwishtems', JSON.stringify(wishlist));
            var icon_length = $(self).find("span").length;
            if(icon_length != 0){
                $wbwishlistBtn.html('<span class="wbaddtowish"><svg><use xlink:href="#wish"></use></svg></span><span class="wbloadtowish wishanimated"><svg><use xlink:href="#refresh"></use></svg></span><span class="wbwishirmv"><svg viewBox="0 0 24 24" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/"><g transform="translate(0 -1028.4)"><path d="m7 1031.4c-1.5355 0-3.0784 0.5-4.25 1.7-2.3431 2.4-2.2788 6.1 0 8.5l9.25 9.8 9.25-9.8c2.279-2.4 2.343-6.1 0-8.5-2.343-2.3-6.157-2.3-8.5 0l-0.75 0.8-0.75-0.8c-1.172-1.2-2.7145-1.7-4.25-1.7z" fill="#fe3869"/></g></svg></span>');
            }
            var wbwishcountp_value = localStorage.getItem('wbwishtemscount');
            $wbwishcount.html(wbwishcountp_value);
        }
    };
    var activateWishItems = function () {
        $wbwishlistBtn.each(function () {
        var productHandle = $(this).attr('data-product-handle');
            if (wishlist.indexOf(productHandle) > -1) {
                $(this).addClass('wishactive');
                var icon_length = $(this).find("span").length;
                if($(this).hasClass('wishactive')){
                    if(icon_length != 0){
                        $(this).html('<span class="wbaddtowish"><svg><use xlink:href="#wish"></use></svg></span><span class="wbloadtowish wishanimated"><svg><use xlink:href="#refresh"></use></svg></span><span class="wbwishirmv"><svg viewBox="0 0 24 24" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/"><g transform="translate(0 -1028.4)"><path d="m7 1031.4c-1.5355 0-3.0784 0.5-4.25 1.7-2.3431 2.4-2.2788 6.1 0 8.5l9.25 9.8 9.25-9.8c2.279-2.4 2.343-6.1 0-8.5-2.343-2.3-6.157-2.3-8.5 0l-0.75 0.8-0.75-0.8c-1.172-1.2-2.7145-1.7-4.25-1.7z" fill="#fe3869"/></g></svg></span>');
                    }
                }else{
                    if(icon_length != 0){
                        $(this).html('<span class="wbaddtowish"><svg><use xlink:href="#wish"></use></svg></span><span class="wbloadtowish wishanimated"><svg><use xlink:href="#refresh"></use></svg></span><span class="wbwishirmv"><svg viewBox="0 0 24 24" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/"><g transform="translate(0 -1028.4)"><path d="m7 1031.4c-1.5355 0-3.0784 0.5-4.25 1.7-2.3431 2.4-2.2788 6.1 0 8.5l9.25 9.8 9.25-9.8c2.279-2.4 2.343-6.1 0-8.5-2.343-2.3-6.157-2.3-8.5 0l-0.75 0.8-0.75-0.8c-1.172-1.2-2.7145-1.7-4.25-1.7z" fill="#fe3869"/></g></svg></span>');
                    }
                }
            }
        });
    };
    var displayWishItems = function () {
        $wishlistCart.each(function () {
        var productHandle = $(this).attr('data-product-handle');
            if (wishlist.indexOf(productHandle) === -1) {
                $(this).remove();
                numProductTiles--;
            }
        });
    };
    var loadWishlist = function () {
        if (window.location.href.indexOf('pages/wishlist') > -1) {
        displayWishItems();
            $('.wbwishloader').fadeOut(2000, function () {
                $('.wbmainwish .wishlist-hero').addClass('wishvisible');
                //$('.wishlist-hero').addClass('wishvisible');
                if (numProductTiles == 0) {
                    $('.wbwishempty').addClass('wishvisible');
                    $('.wbmainwish').hide();
                } else {
                    $('.wbwishempty').hide();
                }
            });
        }
    };
    var bindUIActions = function () {
        $wbwishlistBtn.click(function (e) {
            e.preventDefault();
            updateWishlist(this);
            animateWishlist(this);
        });
    };
    Wishlist.init = function () {
        bindUIActions();
        activateWishItems();
        loadWishlist();
    };
    $("#wbwishcall").click(function(){
        //var raw = localStorage.getItem('wbwishtems');
        //var length = raw.length;
        var length = localStorage.getItem('wbwishtems').length;
        //var i;
        var productHandle = $(self).attr('data-product-handle');
        var isRemove = $(self).hasClass('wishactive');
        for ( var i=length-1; i>= 0; i--){
        var removeIndex = wishlist.indexOf(productHandle);
        wishlist.splice(removeIndex, 1);
        var wbwishcountp = localStorage.getItem('wbwishtemscount');
            if(wbwishcountp != null){
                var wish_ct = Math.max(parseInt(0), 0);
                localStorage.setItem('wbwishtemscount', wish_ct);
            }
            localStorage.setItem('wbwishtems', JSON.stringify(wishlist));
        }
        location.reload(true);
    });
}(window.Wishlist = window.Wishlist || {}, jQuery, undefined));
function reloadPage(){
    location.reload(true);
}